var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home fullscreen flex-container"},[_c('div',{staticClass:"flex-item-center text-center"},[_c('img',{attrs:{"src":require("../assets/img/logo-psi.svg"),"alt":"PSI"}}),_c('beat-loader',{staticStyle:{"margin-top":"40px"},attrs:{"color":this.$colors.blue}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }